export default __webpack_public_path__ + "static/media/groundPart3.cefba7cd.webp";